import { Language } from './base';

const pdash = () => import('../translations/pdash/sl-SI.json');
const webActivities = () => import('../translations/web-activities/sl-SI.json');
const rdashTranslatables = () => import('../translations/rdash-translatables/sl-SI.json');

export default new Language({
    code: 'sl-SI',
    locale: 'sl',
    localName: 'Slovenščina',
    englishName: 'Slovenian',
    territory: 'SI',
    timezones: ['Europe/Ljubljana'],
    notLoadedNamespaces: { pdash, webActivities, rdashTranslatables },
});
